<script>
  import { onMount } from 'svelte';

  import Footer from './components/Footer.svelte';
  import NoteComponent from './components/NoteComponent.svelte';

  let newNote;
  let notes = [];

  onMount(() => {
    getAllNotes();
  });

  const getAllNotes = async () => {
    const res = await fetch('http://localhost:8888/api/getAllNotes').then((res) =>
      res.json()
    );
    notes = res.notes;
    console.log(notes);
    return res.notes;
  };

  const addNote = async () => {
    if (!newNote || newNote.trim().length === 0) return;
    const res = await fetch('http://localhost:8888/api/createNote', {
      method: 'POST',
      body: JSON.stringify({
        newNote: { content: newNote, timestamp: Date.now() },
      }),
    });

    if (res.status === 200) {
      let createdNote = await res.json();
      notes = [...notes, createdNote];
      newNote = '';
    }
  };

  const deleteNote = async (deletedNote) => {
    const res = await fetch('http://localhost:8888/api/deleteNote', {
      method: 'DELETE',
      body: JSON.stringify({
        deletedNote,
      }),
    });

    if (res.status === 200) {
      notes = notes.filter((note) => note !== deletedNote);
    }
  };
</script>

<main>
  <input
    bind:value={newNote}
    type="text"
    on:keyup={(e) => {
      if (e.code === 'Enter') addNote();
    }}
  />
  <button on:click={addNote}>Add New Note</button>

  <div id="noteContainer">
    {#each notes as note (note._id)}
      <NoteComponent note={note.content} on:click={() => deleteNote(note)} />
    {:else}
      <p>No notes...</p>
    {/each}
  </div>

  <Footer />
</main>

<style>
  main {
    text-align: center;
    padding: 1em;
    max-width: 240px;
    margin: 0 auto;
  }

  #noteContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  @media (min-width: 640px) {
    main {
      max-width: none;
    }
  }
</style>
